function colorFor(status: string): string {
  switch (status.toUpperCase()) {
    case 'COMPLETED':
      return 'bg-green-50 text-green-700 border-green-200';
    case 'PENDING':
      return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'CREATED':
      return 'bg-blue-50 text-blue-700 border-blue-200';
    case 'ABANDONED':
    case 'CANCELLED':
      return 'bg-red-50 text-red-700 border-red-200';
    default:
      return 'bg-gray-50 text-gray-700 border-gray-200';
  }
}

export default function KdsStationBadge({
  station,
  status,
}: {
  station: string;
  status: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium border ${colorFor(
        status
      )}`}
      title={`${station} · ${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-60" />
      {station}
      {status && status !== 'COMPLETED' && (
        <span className="text-[9px] opacity-70 ml-0.5">{status}</span>
      )}
    </span>
  );
}
